<template>
  <section :class="{ isScrollable }">
    <div class="actions">
      <button class="icon" @click="$emit('close')" aria-label="Close">
        <fa-icon
          :icon="['fas', 'times']"
          size="lg"
        />
      </button>
    </div>
    <div :style="{ maxHeight }" class="img">
      <img ref="image" :src="image" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'ImageZoomModal',
  props: [
    'image'
  ],
  data() {
    return {
      isScrollable: false,
      maxHeight: 'none'
    }
  },
  created() {
    setTimeout(() => {
      this.onResize();
    }, 250);
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      const buffer = 40;
      const imageHeight = this.$refs.image ? this.$refs.image.clientHeight : 0;
      const maxHeight = window.innerHeight - buffer;
      this.isScrollable = (imageHeight > maxHeight);
      this.maxHeight = `${maxHeight}px`;
    }
  }
}
</script>

<style scoped lang="scss">
section {
  position: relative;
  width: 100%;
  height: 100%;
  font-family: Poppins, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(47, 49, 56);

  ::-webkit-scrollbar {
    width: 14px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 7px;
    background: rgba(255,255,255,0);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    background: rgba(47, 49, 56, 0.6);
    border: 3px solid #fff;
  }

  ::-webkit-scrollbar-button {
    display: none;
  }
}

.actions {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
}

.img {
  position: relative;
  overflow-y: auto;
  scrollbar-color: rgba(47, 49, 56, 0.6) rgba(0,0,0,0);

  img {
    display: block;
    min-width: 100px;
    max-width: 100%;
    margin: 0 auto;
  }
}

button.icon {
  width: 30px;
  height: 30px;
  font-size: 11px;
  border-radius: 4px;
  border: 0;
  padding: 0;
  background: none;
  color: rgba(47, 49, 56, 0.6);
  cursor: pointer;
  transition: background 250ms ease-out,
    color 250ms ease-out;

  &:focus {
    outline: none;
    box-shadow: none;
    background: none;
    color: rgba(47, 49, 56, 0.6);
  }

  &.selected,
  &:hover {
    background: rgba(234, 235, 239, 0.5);
    color: rgb(47, 49, 56);
  }
}

.isScrollable {

  .img {
    margin-right: -15px;
  }
}
</style>
